import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/line-height.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 20C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H21ZM11.3369 5.8623C11.7025 5.68222 12.1235 5.65989 12.5029 5.79492L12.6631 5.8623L12.793 5.93652C13.0768 6.12045 13.2352 6.38077 13.3174 6.52539C13.4229 6.71113 13.5312 6.9521 13.6387 7.18848L17.9102 16.5859C18.1386 17.0886 17.9166 17.6815 17.4141 17.9102C16.9428 18.1244 16.392 17.9427 16.1367 17.5049L16.0898 17.4141L14.5381 14H9.46191L7.91016 17.4141C7.68152 17.9166 7.08862 18.1386 6.58594 17.9102C6.08336 17.6815 5.86135 17.0886 6.08984 16.5859L10.3613 7.18848C10.4688 6.9521 10.5771 6.71113 10.6826 6.52539C10.7766 6.36003 10.9701 6.04304 11.3369 5.8623ZM10.3711 12H13.6289L12 8.41504L10.3711 12ZM21 2C21.5523 2 22 2.44772 22 3C22 3.55228 21.5523 4 21 4H3C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2H21Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as LineHeightIcon };
